import { MainMenu } from '../components/MainMenu';
import { Outlet } from 'react-router';
import { FunctionComponent } from 'react';
import { LocationDrawerProvider } from '@/modules/locations/contexts/LocationDrawerContext';
import { PlaceRounded, SwapHorizRounded } from '@mui/icons-material';
import { Permission } from '@/modules/users/submodules/roles/api/permissions.contracts';

// Minimal menu for guest users - locations and transactions
const GUEST_MENU_ITEM_GROUPS = [
  {
    label: 'locations',
    children: [
      {
        activeRouteIds: ['/app/guest-locations*'],
        label: 'locations',
        url: '/app/guest-locations',
        icon: <PlaceRounded fontSize={'inherit'} />,
        permission: Permission.LOCATIONS_VIEW,
      },
    ],
  },
  {
    label: 'transactions',
    children: [
      {
        activeRouteIds: ['/app/guest-transactions*'],
        label: 'transactions',
        url: '/app/guest-transactions',
        icon: <SwapHorizRounded fontSize={'inherit'} />,
        permission: Permission.TRANSACTIONS_VIEW,
      },
    ],
  },
];

export const GuestApplicationLayout: FunctionComponent = () => {
  return (
    <LocationDrawerProvider>
      <div className="flex min-h-screen w-full">
        <MainMenu mainMenuItemGroups={GUEST_MENU_ITEM_GROUPS} />

        <div className="flex-grow">
          <Outlet />
        </div>
      </div>
    </LocationDrawerProvider>
  );
};
